import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card } from "react-bootstrap";
import { toast } from "react-toastify";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";
import SearchSelect from "views/lib/components/SearchSelect";
import { getRoles, findById, addItem, updateItem } from "actions/admin/actions";

const View = ({
                history,
                match,
                getRoles,
                roles,
                findById,
                addItem,
                updateItem
              }) => {
  const id = match.params.id;
  const [admin, setAdmin] = useState({
    id: null,
    name: "",
    email: "",
    password: "",
    roles: []
  });

  useEffect(() => {
    if (id) {
      findById(id, result => {
        setAdmin(oldAdmin => ({
          ...oldAdmin,
          ...result,
          roles: (result.roles || []).map(i => ({
            label: i,
            value: i
          }))
        }));
      });
    }
  }, [id, findById]);

  useEffect(() => {
    if (!roles.length) getRoles();
  }, [roles.length, getRoles]);

  const handleChange = (ev) => {
    setAdmin({
      ...admin,
      [ev.target.name]: ev.target.value
    });
  };

  const handleSave = () => {
    const changedItem = {
      ...admin,
      roles: admin.roles.map(i => i.value)
    };

    if (changedItem.name.length < 1 || changedItem.email < 5) return false;

    const callback = () => {
      history.goBack();
    };

    if (id) {
      if (changedItem.password === "") delete changedItem.password;
      updateItem(id, changedItem, callback);
    } else {
      delete changedItem.id;
      if (changedItem.password.length < 6) {
        toast("Password field should be 6 or more symbols", {
          type: toast.TYPE.ERROR,
        });
        return;
      }
      addItem(changedItem, callback);
    }
  };

  const roleOptions = roles.map(value => ({
    label: value,
    value
  }));

  return (
    <div className="m-2 position-relative">
      <Card className="rounded-0">
        <Card.Header>
          <div className="d-inline-flex align-items-center">
            {id ? "Edit Admin" : "Create Admin"}
          </div>
        </Card.Header>
        <Card.Body>
          <table className="table table-bordered m-0">
            <tbody>
            <tr>
              <th style={{ width: 120 }}>Name</th>
              <td>
                <input minLength={1} className="form-control" type="text" name="name" value={admin.name}
                       onChange={handleChange}/>
              </td>
            </tr>
            <tr>
              <th>Email</th>
              <td>
                <input minLength={5} className="form-control" type="email" name="email" value={admin.email}
                       onChange={handleChange}/>
              </td>
            </tr>
            <tr>
              <th>Roles</th>
              <td>
                <SearchSelect
                  className="search-select"
                  onChange={option => {
                    setAdmin({
                      ...admin,
                      roles: option
                    });
                  }}
                  name="roles"
                  options={roleOptions}
                  isSearchable={false}
                  isClearable={false}
                  isLoading={!roleOptions.length}
                  isMulti={true}
                  value={admin.roles}
                />
              </td>
            </tr>
            <tr>
              <th>Password</th>
              <td>
                <input minLength={6} className="form-control" type="text" name="password" value={admin.password}
                       onChange={handleChange}/>
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="text-right">
                <button
                  className="btn btn-warning"
                  title={id ? "Update" : "Create"}
                  onClick={handleSave}
                >
                  {id ? "Update" : "Create"}
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </Card.Body>
      </Card>
    </div>
  );
};

const mapStateToProps = state => ({
  roles: state.admin.roles
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getRoles: bindActionCreators(getRoles, dispatch),
  findById: bindActionCreators(findById, dispatch),
  addItem: bindActionCreators(addItem, dispatch),
  updateItem: bindActionCreators(updateItem, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(View);



// WEBPACK FOOTER //
// ./src/views/pages/admin/view.js